/* global $ */
import { settingsToQueryString } from './video-utils';
import { apiEndpoints } from 'apiService';
import { seasonSettingsToQueryString } from './season-utils';

export function getVideos(settings, siteId, showLoading = () => {}) {
    showLoading();
    let data;
    const componentSettings = { ...settings };

    if (componentSettings.selectedRegions) {
        data = {
            country: componentSettings.selectedRegions.map(({ value }) => value).join(',')
        };
        delete componentSettings.selectedRegions;
    }

    const url = `${apiEndpoints.MEDIA_MANAGER_ASSETS.replace(
        '{siteId}',
        siteId
    )}${settingsToQueryString(componentSettings)}`;

    return $.ajax({
        type: 'GET',
        url,
        data,
        cache: false,
        error: (xhr, status, err) => {
            console.error(xhr, status, err.toString());
        }
    });
}

export function getSeasons(API, siteId, showId, settings, showLoading = () => {}) {
    showLoading();
    const componentSettings = { ...settings };
    const DomainUrl = API?.API_BASE_URL || '';
    const url = `${DomainUrl}${apiEndpoints.MEDIA_MANAGER_SEASONS.replace(
        '{siteId}',
        siteId
    )}${seasonSettingsToQueryString(showId, componentSettings)}`;

    return $.ajax({
        type: 'GET',
        url,
        cache: false,
        error: (xhr, status, err) => {
            console.error(xhr, status, err.toString());
        }
    });
}

export function getShows(siteId, input) {
    const url = apiEndpoints.MEDIA_MANAGER_SEARCH_SHOWS.replace('{siteId}', siteId);
    const data = {
        query: input,
        ['page-size']: 50
    };

    return $.ajax({
        type: 'GET',
        url,
        data,
        cache: false,
        error: (xhr, status, err) => {
            console.error(xhr, status, err.toString());
        }
    });
}
